import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiMail } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function Templates({ size = 1 }: IWithSize & WithTranslation) {
  const userId = useSelector(getUserId)

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Message Templates Menu Opened', 1)
    Mixpanel.track('Message Templates Menu Item Used', {})
  }

  return (
    <MenuElement size={size} alignCenter={true}>
      <Link onClick={trackClick} size={size} to={'/templates'}>
        <Flex alignCenter={true}>
          <b>
            <FiMail size={16 * size} />
          </b>
          <Label size={size} primary={true}>
            <Trans i18nKey={'custom_messages_title'}>Szablony Wiadomości</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Templates
